import { WarningBanner, WarningDialog } from "@graffer-inc/console-design-kit";
import { UserEntity } from "../../../../../application/domain/user/user-entity";
import React from "react";
import { ChangeAuthMethodService } from "../../../../../application/service/settings/users/change-auth-method-service";
import { toast } from "react-toastify";

type Props = {
  user: UserEntity;
  onCloseDialog: () => void;
};

export const ChangeAuthMethodToPasswordDialog: React.FC<Props> = ({
  user,
  onCloseDialog,
}) => {
  const [processErrorMessage, setProcessErrorMessage] = React.useState<
    string | null
  >(null);

  const onClose = () => {
    setProcessErrorMessage(null);
    onCloseDialog();
  };

  const onProcess = async () => {
    try {
      await ChangeAuthMethodService.ChangeAuthMethod(user, "password", null);

      toast.success("認証方式をパスワード認証に変更しました");
      onClose();
    } catch (e) {
      setProcessErrorMessage(e.message);
    }
  };

  const dialogContent = () => {
    return (
      <section className="modal-card-body">
        {processErrorMessage && (
          <section style={{ marginBottom: "1.5rem" }}>
            <WarningBanner
              message="認証方式の変更に失敗しました"
              description={processErrorMessage}
            />
          </section>
        )}
        <p>以下のアカウントをパスワード認証に変更します。</p>
        <p>
          変更後、登録されているメールアドレスに仮パスワードが送信されます。
        </p>
        <section style={{ marginTop: "1.5rem" }}>
          <div className="field">
            <label className="label">ユーザーID</label>
            {user.id}
          </div>
          <div className="field">
            <label className="label">アカウント名</label>
            {user.accountName}
          </div>
          <div className="field">
            <label className="label">氏名</label>
            {user.name}
          </div>
          <div className="field">
            <label className="label">メールアドレス</label>
            {user.email}
          </div>
        </section>
      </section>
    );
  };

  return (
    <>
      <WarningDialog
        title={"パスワード認証へ変更"}
        contents={dialogContent()}
        onCancel={onClose}
        cancelText="キャンセル"
        proceedText="変更する"
        onProceed={onProcess}
      />
    </>
  );
};
